import { Grid } from '@mui/material';
import { getNodesForDecisionAvailables } from 'lib/api';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { errorHandler } from 'lib/functions/errors';
import { CompanyComitee } from 'lib/types/models';
import { DecisionNode } from 'lib/types/models';
import {
  Node,
  RevisionObjective,
} from 'pages/Settings/Components/Risk/Components/DecisionEngines/components/Create/types';
import { CategorizedNodes } from 'pages/Settings/Components/Risk/Components/DecisionEngines/components/Create/types';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import LineNodesConfiguration from './Configuration';
import MatrixVisualization from './Visualization';

type Props = {
  decisionNodesAssignation: Node[];
  setDecisionNodesAssignation: (nodes: Node[]) => void;
  revisionObjective: RevisionObjective;
};

const MatrixEngine = (props: Props) => {
  const {
    revisionObjective,
    decisionNodesAssignation,
    setDecisionNodesAssignation,
  } = props;
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const [decisionNodes, setDecisionNodes] = useState<DecisionNode[]>([]);
  const [categorizedNodes, setCategorizedNodes] = useState<CategorizedNodes>(
    {},
  );
  const [comitees, setComitees] = useState<CompanyComitee[]>([]);

  const fetchDecisionNodes = async () => {
    try {
      setLoading(true);
      const nodes = await getNodesForDecisionAvailables(dispatch, {
        revisionObjective,
      });
      if (nodes) {
        setCategorizedNodes(nodes.categorizedNodes);
        setDecisionNodes(nodes.decisionNodes);
        setComitees(nodes.comiteesAvailables);
      }
    } catch (error) {
      errorHandler(dispatch, error, 'Error al obtener los nodos del motor');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void fetchDecisionNodes();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;

  return (
    <Grid container style={{ paddingTop: '20px' }}>
      <Grid item xs={4}>
        <LineNodesConfiguration
          revisionObjective={revisionObjective}
          decisionNodesAssignation={decisionNodesAssignation}
          setDecisionNodesAssignation={setDecisionNodesAssignation}
          decisionNodes={decisionNodes}
          categorizedNodes={categorizedNodes}
          setDecisionNodes={setDecisionNodes}
          comiteesAvailables={comitees}
        />
      </Grid>
      <Grid item xs={8} style={{ overflowX: 'auto' }}>
        <MatrixVisualization
          nodes={decisionNodesAssignation}
          decisionNodes={decisionNodes}
        />
      </Grid>
    </Grid>
  );
};

export default MatrixEngine;
